import { render, staticRenderFns } from "./ReturnDepositBillDetailOld.vue?vue&type=template&id=4c058418&scoped=true"
import script from "./ReturnDepositBillDetailOld.vue?vue&type=script&lang=js"
export * from "./ReturnDepositBillDetailOld.vue?vue&type=script&lang=js"
import style0 from "./ReturnDepositBillDetailOld.vue?vue&type=style&index=0&id=4c058418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c058418",
  null
  
)

export default component.exports